import { queryString } from '@/munio/http'
import Wrapper from '@app/Wrapper.js'
import Filters from '@component/Toolbar/Filters.vue'
import CSV from '@component/Toolbar/CSV.vue'
import { createApp, h, reactive } from 'vue'

Munio.Toolbar = {
  Filters: class extends Wrapper {
    constructor(selector, options) {
      super(selector, { options })
    }

    get name() {
      return 'LegacyFilters'
    }

    component() {
      return Filters
    }
  },

  CSV: class {
    constructor(selector, baseUrl, options) {
      const state = reactive({ loading: false, disabled: false, csv: options.csv })

      createApp({
        name: 'Munio.Toolbar.CSV',
        data: () => state,
        render: (context) => h(CSV, { loading: context.loading, disabled: context.disabled, csv: context.csv }),
      }).mount(selector)

      Munio.Events.$on('csv.export', async (settings) => {
        try {
          const url = baseUrl || window.location.protocol + '//' + window.location.hostname + window.location.pathname
          const query = queryString()

          state.loading = true
          await Munio.downloadCSV(url, { ...settings }, query)
        } catch (err) {
          console.error(err)
        } finally {
          state.loading = false
        }
      })
    }

    get name() {
      return 'LegacyCSV'
    }

    component() {
      return CSV
    }
  },
}
